import type { ReactNode } from "react";

export function EmptyResult({ icon, text }: { icon: ReactNode; text: string }) {
  return (
    <div className="flex items-center gap-2 rounded-xl border border-dashed border-stone-200 px-3 py-4 text-xs text-stone-500 dark:border-white/10 dark:text-stone-400">
      {icon}
      {text}
    </div>
  );
}
